"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetLootShopItemsResponseAllOfToJSON = exports.GetLootShopItemsResponseAllOfFromJSONTyped = exports.GetLootShopItemsResponseAllOfFromJSON = void 0;
var _1 = require("./");
function GetLootShopItemsResponseAllOfFromJSON(json) {
    return GetLootShopItemsResponseAllOfFromJSONTyped(json, false);
}
exports.GetLootShopItemsResponseAllOfFromJSON = GetLootShopItemsResponseAllOfFromJSON;
function GetLootShopItemsResponseAllOfFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'items': (json['items'].map(_1.MenuItemFromJSON)),
    };
}
exports.GetLootShopItemsResponseAllOfFromJSONTyped = GetLootShopItemsResponseAllOfFromJSONTyped;
function GetLootShopItemsResponseAllOfToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'items': (value.items.map(_1.MenuItemToJSON)),
    };
}
exports.GetLootShopItemsResponseAllOfToJSON = GetLootShopItemsResponseAllOfToJSON;
